<div class="p-a-10-x p-a-10-l bg-col-w-x bg-col-w-l">
    <ng-content></ng-content>
</div>